import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function SettingsClientCredentialsListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SettingsClientCredentialsListing', {
		url: '/admin/credentials',
		controllerAs: 'vm',
		controller: SettingsClientCredentialsListingCtrl,
		templateUrl: '/ng/hub/Settings/ClientCredentials/Listing/SettingsClientCredentialsListingCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			$title: () => 'Credentials',
		},
	});
}

export class SettingsClientCredentialsListingCtrl {
	constructor(Api, modal, $timeout) {
		'ngInject';
		this.Api = Api;
		this.modal = modal;
		this.$timeout = $timeout;
		this.columns = [
			{ field: 'id', label: 'Id', sortable: false },
			{ field: 'client_id', label: 'Client Id', sortable: false },
			{ field: 'type', label: 'Type', sortable: false },
			{ field: 'username', label: 'Username', sortable: false },
			{ field: 'values', label: 'Values', sortable: false },
			// { field: 'metadata', label: 'Metadata', sortable: false }, // this column makes the table really wide
			{ field: 'created', label: 'Date Created', sortable: false },
			{ field: 'created_by', label: 'Created By', sortable: false },
			{ field: 'is_active', label: 'Is Active', sortable: false },
		];
		this.actions = [
			{ label: 'Delete', icon: 'cancel', callback: this.deactivate.bind(this) },
			{ label: 'Edit', icon: 'pencil', callback: this.edit.bind(this) },
		];
		this.filters = {};
	}

	addCredentials() {
		const reload = this.reload.bind(this);
		this.modal
			.state('hub.loggedin.SettingsClientCredentialsAddEdit', {
				heading: 'Edit',
				// modal._trackPageView will have problems if `params` isn't sent
				params: {},
			})
			.then(reload, reload);
	}

	edit(record) {
		const reload = this.reload.bind(this);
		this.modal
			.state('hub.loggedin.SettingsClientCredentialsAddEdit', {
				heading: 'Edit',
				params: { id: record.id },
			})
			.then(reload, reload);
	}

	deactivate(record) {
		// don't do anything if already deactivated
		if (record.is_active == 0) {
			return;
		}
		this.Api.delete(`/credentials/${record.id}`).then(() => {
			record.is_active = 0;
			this.reload();
		});
	}

	reload() {
		this.$timeout(() => {
			this.filters.cb = (+new Date() - 1487628121261).toString(36);
		});
	}
}
